import { ApiCaller } from '../../../api-caller.service';
import { EtxeAdminConnector } from './admin/etxe.admin.connector';
import { AgentCardConnector } from './agent-cards';
import { AgentConnector } from './agents';
import { PropertyApplicationsConnector } from './applications';
import { AppointmentsConnector } from './appointments';
import { DiscussionsConnector } from './discussions';
import { PropertiesConnector } from './properties';
import { EtxePublicConnector } from './public';

export class EtxeConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  applications = () => new PropertyApplicationsConnector(this.apiCaller, `${this.prefix}/user`);
  appointments = () => new AppointmentsConnector(this.apiCaller, `${this.prefix}/user`);
  properties = () => new PropertiesConnector(this.apiCaller, `${this.prefix}/user`);
  discussions = () => new DiscussionsConnector(this.apiCaller, `${this.prefix}/user`);
  agent = () => new AgentConnector(this.apiCaller, `${this.prefix}/user`);
  agents = () => this.agent();
  agentCards = () => new AgentCardConnector(this.apiCaller, `${this.prefix}/user`);
  public = () => new EtxePublicConnector(this.apiCaller, `${this.prefix}/public`);
  admin = () => new EtxeAdminConnector(this.apiCaller, `${this.prefix}/admin`);
}
